






import Vue, { PropType } from "vue";

import Pell from "pell";

import Loading from "../general/Loading.vue";

import Utils from "../../shared/Utils";

export default Vue.extend({
  name: "HtmlEditor",
  components: {
    Loading,
  },
  props: {
    actions: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
    hideActions: {
      type: Boolean,
      default: false,
    },
    value: String,
    allowedTags: Array as PropType<string[]>,
  },
  data() {
    return {
      Utils: Utils,
      pellEditor: null as any | null,
      allActions: [
        {
          name: "bold",
          title: "Auswahl fett formatieren",
          icon: '<div class="iconbtn small bold-text"></div>',
        },
        {
          name: "underline",
          title: "Auswahl unterstreichen",
          icon: '<div class="iconbtn small underline-text"></div>',
        },
        {
          name: "ulist",
          title: "Liste einfügen",
          icon: '<div class="iconbtn small list"></div>',
        },
        {
          name: "link",
          title: "Link einfügen",
          icon: '<div class="iconbtn small hyperlink"></div>',
          result: () => {
            const url = window.prompt("Geben Sie den Link ein");
            if (url) {
              Pell.exec("createLink", url);
            }
          },
        },
        {
          name: "mailGreetingsShort",
          title: "Platzhalter für Ansprache (Hallo Mara) einfügen",
          icon: "Ansprache: Vorname",
          result: () => {
            Pell.exec("insertText", "{{Ansprache kurz}}");
          },
        },
        {
          name: "mailGreetingsLong",
          title: "Platzhalter für Ansprache (Hallo Mara Muster) einfügen",
          icon: "Ansprache: Vor- & Nachname",
          result: () => {
            Pell.exec("insertText", "{{Ansprache lang}}");
          },
        },
        {
          name: "mailGreetingsWiSaShort",
          title: "Platzhalter für Ansprache (Hallo Frau Muster) einfügen",
          icon: "Ansprache: Anrede Nachname",
          result: () => {
            Pell.exec("insertText", "{{Ansprache Anrede kurz}}");
          },
        },
        {
          name: "mailGreetingsWiSaLong",
          title: "Platzhalter für Ansprache (Hallo Frau Mara Muster) einfügen",
          icon: "Ansprache: Anrede Vor- & Nachname",
          result: () => {
            Pell.exec("insertText", "{{Ansprache Anrede lang}}");
          },
        },
        {
          name: "mailFirstName",
          title: "Platzhalter für Vornamen einfügen",
          icon: "Vorname",
          result: () => {
            Pell.exec("insertText", "{{Vorname}}");
          },
        },
        {
          name: "mailLastName",
          title: "Platzhalter für Vornamen einfügen",
          icon: "Nachname",
          result: () => {
            Pell.exec("insertText", "{{Nachname}}");
          },
        },
      ] as object[],
    };
  },
  mounted() {
    this.pellEditor = Pell.init({
      element: <HTMLInputElement>this.$refs["pell-editor"],
      onChange: (html: string) => this.returnHtml(html),
      defaultParagraphSeparator: "p",
      actions: this.activeActions,
      classes: {
        actionbar: "html-editor-toolbar",
        button: "html-editor-button",
        content: "html-editor-content",
        selected: "html-editor-button-selected",
      },
    });

    this.pellEditor.content.innerHTML = this.value;
  },
  methods: {
    returnHtml(html: string) {
      this.$emit("getHtmlContent", this.Utils.sanitizeHtml(html, this.allowedTags));
      //this.$emit("getHtmlContent", html);
    },
  },
  watch: {
    /* value() {
      this.pellEditor.content.innerHTML = this.value;
    }, */
  },
  computed: {
    activeActions(): object[] {
      return this.allActions.filter((i: any) => this.actions.includes(i.name)) ?? [];
    },

    isActionsHide(): Boolean {
      var isActionsHide = this.hideActions;

      if (!isActionsHide) {
        if (this.activeActions.length <= 0) {
          isActionsHide = true;
        }
      }

      return isActionsHide;
    },
  },
});
